import { useEffect, useMemo, useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import SearchField from '@/shared-components/inputs/components/SearchField';
import Loader from '@/shared-components/loader/Loader';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';

import './TagPicker.css';

const MINIMUM_QUERY_LENGTH = 2;

export default function TagPicker({ open, close, tags, onSelect, onRemove }) {
  const [query, setQuery] = useState('');
  const normalizedQuery = query.trim();
  const isSearchActive = open && normalizedQuery.length >= MINIMUM_QUERY_LENGTH;
  const searchQuery = useMemo(() => ({ q: normalizedQuery }), [normalizedQuery]);

  const { loading, queryData } = useQuery(
    'post_search_users',
    `${config.apis.api.url}/search/user`,
    searchQuery,
    { injectToken: true, disabled: !isSearchActive }
  );
  const users = queryData?.data?.data || [];

  useEffect(() => {
    if (!open) setQuery('');
  }, [open]);

  const selectTag = tag => {
    if (onSelect(tag) !== false) {
      setQuery('');
      close();
    }
  };

  return (
    <PopupToBottomSheet
      open={open}
      close={close}
      popupOptions={{ opacity: true, onBackgroundClick: close }}
    >
      <div className="generic-popup_content post-tags__container">
        <div className="generic-popup__header">
          <label className="generic-popup__header-text" htmlFor="post-tag-search">Add tag</label>
          <XIcon className="generic-popup__close" onClick={close} />
        </div>
        <div className="post-tags__search-container">
          <SearchField
            leading={<span className="post-tags__search-username-entry">@</span>}
            surface="background"
            id="post-tag-search"
            value={query}
            onChange={event => setQuery(event.target.value)}
            onClear={() => setQuery('')}
            placeholder="Search username"
            autoComplete="off"
            autoFocus
          />
          {isSearchActive && (
            <div className="post-tags__search-suggestions">
              {loading && (
                <div className="post-tags__search-loading">
                  <Loader inline thin />
                </div>
              )}
              {!loading && users.map(user => (
                <button
                  key={user._id}
                  type="button"
                  onClick={() => selectTag(user)}
                  disabled={tags.some(tag => tag._id === user._id)}
                >
                  <UserProfileImage
                    className="post-tags__suggestion-image"
                    image={user.user_image?.image_id}
                    typeOfProfile={user.user_type}
                  />
                  <span className="post-tags__suggestion-username">{user.user_username}</span>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="post-tags__tags">
          {tags.map(tag => (
            <button key={tag._id} type="button" onClick={() => onRemove(tag._id)}>
              @{tag.user_username} ×
            </button>
          ))}
        </div>
      </div>
    </PopupToBottomSheet>
  );
}
